function initVideoPlayer() {
    var video = document.getElementById('video-html5-player');
    var playButton = document.getElementById('video-play-button');
    var pauseButton = document.getElementById('video-pause-button');
    var videoPlayerContainer = document.getElementById('video-vimeo-player');

    playButton.addEventListener('click', function () {
        video.play();
        playButton.style.display = 'none';
        pauseButton.style.display = 'flex';
    });

    pauseButton.addEventListener('click', function () {
        video.pause();
        playButton.style.display = 'flex';
        pauseButton.style.display = 'none';
    });

    video.addEventListener('ended', function () {
        playButton.style.display = 'flex';
        pauseButton.style.display = 'none';
        video.currentTime = 0;
    });

    video.addEventListener('play', function () {
        playButton.style.display = 'none';
        pauseButton.style.display = 'flex';
    });

    video.addEventListener('pause', function () {
        playButton.style.display = 'flex';
        pauseButton.style.display = 'none';
    });

    videoPlayerContainer.addEventListener('mouseover', function () {
        if (!video.paused) {
            pauseButton.style.display = 'flex';
        }
    });

    videoPlayerContainer.addEventListener('mouseout', function () {
        if (!video.paused) {
            pauseButton.style.display = 'none';
        }
    });
}

document.addEventListener('DOMContentLoaded', function() {
    var videoElement = document.getElementById('video-html5-player');
    if (videoElement) {
        initVideoPlayer();
    }
});